import {
  REQUEST_PROPERTIES,
  RECEIVE_PROPERTIES,
  FINISH_PROPERTIES_FETCHING,
  RECEIVE_PROPERTIES_ERROR,
  SET_NO_ROUTE_ACCESS,
} from '../actions/properties';

export const initialState = {
  brandShopsWideLayoutThreshold: 0,
  error: null,
  facebookDomainVerificationId: null,
  isFetching: false,
  noRouteAccess: false,
  oneTrustDomainId: '',
  ospSettingsAddressesRedirectUrl: null,
  received: false,
  thirdPartyScriptsRestrictedPages: [],
  usePredefinedLabelForEDLP: false,
};

const ACTIONS = {
  [SET_NO_ROUTE_ACCESS]: ({ state, action }) => ({ ...state, noRouteAccess: action.action || true }),
  [REQUEST_PROPERTIES]: ({ state }) => ({ ...state, isFetching: true }),
  [RECEIVE_PROPERTIES]: ({ state, action }) => {
    const {
      brandShopsWideLayoutThreshold,
      facebookDomainVerificationId,
      oneTrustDomainId,
      ospSettingsAddressesRedirectUrl,
      thirdPartyScriptsRestrictedPages,
      usePredefinedLabelForEDLP,
    } = action;

    return {
      ...state,
      brandShopsWideLayoutThreshold,
      facebookDomainVerificationId,
      oneTrustDomainId,
      ospSettingsAddressesRedirectUrl,
      thirdPartyScriptsRestrictedPages,
      usePredefinedLabelForEDLP,
      error: null,
      received: true,
    };
  },
  [FINISH_PROPERTIES_FETCHING]: ({ state }) => ({ ...state, isFetching: false }),
  [RECEIVE_PROPERTIES_ERROR]: ({ action }) => ({ ...initialState, error: action.error, isFetching: false }),
};

export default function properties(state = initialState, action) {
  return ACTIONS[action.type] ? ACTIONS[action.type]({ state, action }) : state;
}
